export default "__VITE_ASSET__3SGRZFbz__"